import { getTranslateNsT } from "@/utils/getTranslateNsT";

export default function translatePayMethod(value) {
  const t = getTranslateNsT("center", { returnObjects: true });
  const payMethod = Array.from({ length: 17 }).map((_, index) => {
    return t(`add_invoice_pay_method_arr_${index}`) || "";
  });
  payMethod[30] = t("pay_method_ali_qingyun");
  payMethod[31] = t("pay_method_wechat_qingyun");
  payMethod[37] = t("pay_method_outline_qingyun");
  payMethod[38] = t("pay_method_wechat_mini_app");
  payMethod[41] = t("pay_method_ali_gpu_qingyun");
  payMethod[42] = t("pay_method_wechat_gpu_qingyun");
  payMethod[43] = t("pay_method_outline_gpu_qingyun");
  payMethod[50] = t("pay_method_give_member");
  return payMethod[value];
}
